/* GA4: existing property, Shopify consent, no search terms or affiliate query strings. */
(() => {
  'use strict';
  const tagId='G-27K38CBD1C';
  const preview=document.documentElement.dataset.bpPreview==='true';
  if(preview) return;
  let started=false;
  const allowed=()=>Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed());
  const send=(name,params={})=>{
    if(!started||!allowed())return;
    window.gtag('event',name,{send_to:tagId,...params});
  };
  function sync(){
    if(!allowed()){
      window['ga-disable-'+tagId]=true;
      if(started) window.gtag('consent','update',{analytics_storage:'denied'});
      return;
    }
    window['ga-disable-'+tagId]=false;
    if(started){window.gtag('consent','update',{analytics_storage:'granted'});return;}
    started=true;
    window.dataLayer=window.dataLayer||[];
    window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};
    window.gtag('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    window.gtag('js',new Date());
    const page=location.origin+location.pathname;
    let referrer='';try{referrer=document.referrer?new URL(document.referrer).origin:'';}catch{}
    const campaign={};const query=new URLSearchParams(location.search);
    const sources=['x','tiktok','instagram','youtube'];
    if(sources.includes(query.get('utm_source'))&&query.get('utm_medium')==='social'){
      campaign.campaign_source=query.get('utm_source');campaign.campaign_medium='social';
      if(['game-guide','after-work','controller-guide','launch'].includes(query.get('utm_campaign')))campaign.campaign_name=query.get('utm_campaign');
      // Managed content IDs only: P-001..P-999, optionally -v01..-v99.
      // Never forward arbitrary text, email, full URLs or duplicated parameters.
      const content=query.get('utm_content');
      const managedContent=typeof content==='string' && content===content.trim() && /^P-(?!000)[0-9]{3}(?:-v(?!00)[0-9]{2})?$/.test(content);
      if(query.getAll('utm_content').length===1 && (['profile','post','video'].includes(content)||managedContent))campaign.campaign_content=content;
    }
    window.gtag('config',tagId,{...campaign,page_location:page,page_title:location.pathname==='/search'?'サイト内検索 | ぶっちゃけパンダ':document.title,page_referrer:referrer,allow_google_signals:false,allow_ad_personalization_signals:false});
    const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+tagId;document.head.append(script);
  }
  document.addEventListener('visitorConsentCollected',sync);
  if(window.Shopify?.customerPrivacy)sync();
  else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)sync();});
  document.addEventListener('click',event=>{
    const a=event.target.closest?.('a[href]');if(!a)return;
    let url;try{url=new URL(a.href,location.href);}catch{return;}
    if(a.dataset.bpJourney&&url.origin===location.origin)send('bp_journey_click',{link_area:a.dataset.bpJourney,content_id:url.pathname});
    if(['x.com','twitter.com','www.tiktok.com','tiktok.com'].includes(url.hostname)&&a.closest('.bp-footer,.bp-journey'))send('bp_social_click',{link_domain:url.hostname,link_area:a.closest('.bp-journey')?'article-end':'footer'});
    if(url.origin===location.origin&&url.pathname.startsWith('/blogs/')){
      const parts=url.pathname.split('/').filter(Boolean);
      const article=parts.length===3&&parts[2]!=='tagged';
      send(article?'bp_article_open':'bp_category_open',{content_id:url.pathname,link_area:a.closest('.bp-home')?'home':a.closest('.bp-related')?'related':a.closest('.bp-journey')?'article-end':a.closest('.bp-discovery')?'guide':a.closest('header')?'header':'content'});
    }else if(url.protocol==='https:'&&url.hostname==='hb.afl.rakuten.co.jp'){
      const params={link_domain:url.hostname,page_path:location.pathname};
      const ids=['aff-mobile-001','aff-switch-001','aff-headset-001'];
      if(ids.includes(a.dataset.bpAffiliateId))params.affiliate_id=a.dataset.bpAffiliateId;
      if(['article-end','comparison','product-card'].includes(a.dataset.bpLinkArea))params.link_area=a.dataset.bpLinkArea;
      send('affiliate_click',params);
    }
  });
  document.addEventListener('submit',event=>{
    const form=event.target;if(!(form instanceof HTMLFormElement))return;
    let url;try{url=new URL(form.action,location.href);}catch{return;}
    if(url.origin===location.origin&&url.pathname==='/search')send('bp_search_submit',{search_location:form.closest('.bp-home')?'home':form.closest('header')?'header':'content'});
  });
  // One threshold per page, not a stream of scroll events.
  const article=document.querySelector('.article-template__content');
  if(article&&'IntersectionObserver' in window){
    const marker=document.createElement('span');marker.setAttribute('aria-hidden','true');marker.style.cssText='display:block;height:1px';article.append(marker);
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&allowed()&&started){send('bp_article_end',{page_path:location.pathname});observer.disconnect();}},{threshold:1});observer.observe(marker);
  }
})();
